import styled from 'styled-components'
import { Colors } from 'cio-design-library/design-tokens'
import Typography, { FontWeights } from 'builder/styles/typography'
import Media from 'builder/styles/media'
import { PADDING } from './components/Paywall/styles'

export const ContainerWithPaywall = styled.div`
  background: linear-gradient(360deg, #f7f9fc -3.32%, #ffffff 100%);
  padding: ${32 - PADDING}px ${32 - PADDING}px 0;

  border-radius: 26px 26px 0px 0px;
  user-select: none;

  ${Media.Tablet`
    padding: ${24 - PADDING}px ${24 - PADDING}px 0;
    flex-direction: column;
    margin-bottom: 24px;
  `}

  ${Media.Phone`
    padding: ${16 - PADDING}px ${16 - PADDING}px 0;
    flex-direction: column;
    margin-bottom: 24px;
  `}
`

export const ContainerWithoutPaywall = styled.div`
  padding: 32px;
  background: ${Colors.White};
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  gap: 100px;

  ${Media.Tablet`
      padding: 24px;
  `}

  ${Media.Phone`
      padding: 16px;
  `}
`

export const ChildrenContainer = styled.div`
  background-color: ${Colors.White};
`

export const HeaderContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;

  ${Media.Phone`
    grid-template-columns: 1fr
  `}
`
export const BodyContainer = styled.div`
  display: flex;
  flex-direction: column;
`

export const Title = styled.div`
  color: ${Colors.Indigo50};
  ${FontWeights.Regular};
  ${Typography.Body}
`

export const IdealContent = styled.p`
  color: ${Colors.Neutral60};
  ${FontWeights.Regular};
  ${Typography.Body}
`

export const FutureEmploysSays = styled(IdealContent)`
  padding-top: 72px;
  padding-bottom: 24px;
  ${Media.Phone`
    padding-top: 40px;
    padding-bottom: 8px;

  `}
`

export const IdealBoldContent = styled.span`
  color: ${Colors.Neutral90};
  ${FontWeights.Medium};
`

export const Body = styled.div<{ $hasPaywall?: boolean }>`
  color: ${Colors.Neutral60};
  ${FontWeights.Bold};
  ${Typography.Body}
`
